import { render } from "./sideImage.vue?vue&type=template&id=722fa83a"
import script from "./sideImage.vue?vue&type=script&lang=js"
export * from "./sideImage.vue?vue&type=script&lang=js"

import "./sideImage.vue?vue&type=style&index=0&id=722fa83a&lang=scss"

import exportComponent from "/Users/jeromebart/sites/cdm-quiz/cite-des-metiers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__